// Special Property IDs for featured listings
export const specialPropertyIdList = [
    "07-01-KAZUNO-07",
    "07-01-KAZUNO-15",
    "03-06-KIHO-21",
    "00-03-UCHINADA-05",
    "07-01-NOSHIRO-25",
    "00-05-AGANO-06",
    "07-01-KAZUNO-04",
    "07-01-KAZUNO-13",
    "07-01-KAZUNO-16",
    "01-00-MIHARA-42",
    "00-04-OKAYA-04",
    "00-04-OKAYA-14",
    "00-05-MYOKO-13",
    "07-01-NOSHIRO-08",
    "07-01-NOSHIRO-14",
    "07-01-NOSHIRO-20",
    "00-03-NOTO-24",
    "00-03-NOTO-28",
    "00-03-UCHINADA-00",
    "00-03-UCHINADA-01",
    "00-03-UCHINADA-03",
    "00-05-MITSUKE-14",
    "07-01-KAZUNO-61",
    "01-00-KITAHIROSHIMA-01",
    "01-00-KITAHIROSHIMA-05",
    "07-01-KAZUNO-24",
    "03-06-SUZUKA-13",
    "00-05-AGANO-07",
    "00-03-TSUBATA-00",
    "00-03-TSUBATA-02",
    "00-03-NOTO-19",
    "01-00-MIHARA-34",
    "01-00-MIHARA-38",
    "00-04-OKAYA-10",
    "07-01-NOSHIRO-03",
    "07-01-NOSHIRO-12",
    "07-01-NOSHIRO-13",
    "07-01-KAZUNO-00",
    "07-01-KAZUNO-02",
    "07-01-KAZUNO-05",
    "07-01-KAZUNO-08",
    "07-01-KAZUNO-09",
    "07-01-KAZUNO-10",
    "07-01-KAZUNO-11",
    "07-01-KAZUNO-12",
    "07-01-KAZUNO-14",
    "07-01-KAZUNO-18",
    "07-01-KAZUNO-20",
    "07-01-KAZUNO-26",
    "07-01-KAZUNO-27",
    "07-01-KAZUNO-28",
    "07-01-KAZUNO-29",
    "07-01-KAZUNO-31",
    "07-01-KAZUNO-32",
    "07-01-KAZUNO-36",
    "07-01-KAZUNO-37",
    "07-01-KAZUNO-38",
    "07-01-KAZUNO-42",
    "07-01-KAZUNO-45",
    "07-01-KAZUNO-46",
    "07-01-KAZUNO-47",
    "07-01-KAZUNO-49",
    "07-01-KAZUNO-50",
    "03-02-TAKAISHI-06",
    "00-05-AGANO-01",
    "00-05-AGANO-03",
    "00-05-MYOKO-07",
    "01-00-MIHARA-31",
    "00-04-OKAYA-08",
    "00-04-OKAYA-11",
    "00-04-OKAYA-16",
    "00-04-OKAYA-25",
    "00-04-OKAYA-30",
    "00-04-OKAYA-32",
    "00-04-OKAYA-33",
    "00-04-OKAYA-40",
    "03-06-KIHO-13",
    "00-05-MYOKO-12",
    "00-05-MYOKO-19",
    "00-05-MYOKO-37",
    "00-05-MYOKO-44",
    "07-01-NOSHIRO-02",
    "07-01-NOSHIRO-22",
    "00-05-ITOIGAWA-10",
    "00-05-ITOIGAWA-22",
    "00-05-MITSUKE-11",
    "00-05-MITSUKE-15",
    "07-01-KAZUNO-06",
    "07-01-KAZUNO-22",
    "07-01-KAZUNO-55",
    "07-01-KAZUNO-57",
    "07-01-KAZUNO-58",
    "07-01-KAZUNO-60",
    "07-01-KAZUNO-62",
    "07-01-KAZUNO-63",
    "07-01-YURIHONJO-02",
    "07-01-YURIHONJO-04",
    "07-01-YURIHONJO-08",
    "07-01-YURIHONJO-30",
    "07-01-YURIHONJO-32",
    "SL-00-REALESTATECO-00",
    "SL-00-REALESTATECO-01",
    "SL-00-REALESTATECO-02",
    "SL-00-REALESTATECO-03",
    "SL-00-REALESTATECO-04",
    "SL-00-REALESTATECO-05",
    "SL-00-REALESTATECO-06",
    "SL-00-REALESTATECO-07",
  ];
  
  export default specialPropertyIdList;




